import { getFileSize } from '../../../utils/format';
import { acceptExtensions } from '../components/NDFL3/services/NDFL3FileService';
import { isString, round } from 'lodash';

export function checkFileExtensions(inputFiles, accept = acceptExtensions) {
  let acceptArr = accept;

  if (isString(accept)) {
    acceptArr = accept.split(', ');
  }

  const acceptArray = acceptArr.map((ext) => ext.toLowerCase().slice(1));
  const validFilename = Array.prototype.reduce.call(
    inputFiles,
    (response, file) => response && ~acceptArray.indexOf(file.name.split('.').pop().toLowerCase()),
    true,
  );

  if (!validFilename) {
    throw 'Недопустимое расширение файла';
  }
}

/**
 * gets byte array from fileObject
 * @param file
 * @returns {Promise<any>}
 */
export function getByteData(file) {
  return new Promise((resolve) => {
    let reader = new FileReader();
    reader.onload = function () {
      let arrayBuffer = reader.result;
      // let array = new Uint8Array(arrayBuffer);
      resolve({
        isOk: true,
        data: arrayBuffer,
      });
    };
    reader.readAsArrayBuffer(file);
  });
}

export const convertMbtoBytes = (value) => {
  return value * 1024 * 1024;
};

export const convertBytesToMb = (value) => {
  return round(value / 1024 / 1024);
};

export const checkSingleFileSize = (inputFile, maxFileSizeMb) => {
  const maxFileSize = convertMbtoBytes(maxFileSizeMb);
  const singleFileSizeConstraint = getFileSize(maxFileSize);
  if (inputFile.size > maxFileSize) {
    throw new Error(
      `Максимальный размер файла – ${singleFileSizeConstraint.size}${singleFileSizeConstraint.units}`,
    );
  }
};
export const checkAllFilesSize = (inputFiles, options) => {
  const {
    files: storedFiles = [],
    allFilesMaxSizeMb,
    checkSingleFileSize,
    maxFileSizeMb,
    fileAvailableSizeMb,
  } = options;
  const allFilesMaxSize = convertMbtoBytes(allFilesMaxSizeMb);
  const maxFileSize = convertMbtoBytes(maxFileSizeMb);
  const fileAvailableSize = convertMbtoBytes(fileAvailableSizeMb || 0);

  const singleFileSizeConstraint = getFileSize(maxFileSize);

  if (checkSingleFileSize) {
    Array.prototype.reduce.call(
      inputFiles,
      (size, file) => {
        if (+file.size > maxFileSize) {
          throw new Error(
            `Максимальный размер файла – ${singleFileSizeConstraint.size}${singleFileSizeConstraint.units}`,
          );
        }
      },
      0,
    );
  }

  const storedFilesSize =
    storedFiles.length > 0 ? storedFiles.reduce((size, file) => (size += +file.size), 0) : 0;
  const inputFilesSize = Array.prototype.reduce.call(
    inputFiles,
    (size, file) => +file.size + size,
    0,
  );
  const allFilesSize = +storedFilesSize + inputFilesSize;
  const inputFilesArray = [...inputFiles]; // convert FileList to Array
  const hasMaxSizeError =
    inputFilesArray.length > 0 &&
    (fileAvailableSizeMb || fileAvailableSizeMb === 0) &&
    inputFilesSize > fileAvailableSize;

  if (allFilesSize > allFilesMaxSize || hasMaxSizeError) {
    const size = getFileSize(allFilesMaxSize);
    throw `Суммарный размер файлов не должен превышать ${size.size}${size.units}`;
  }
};
